import { MantineTransition, Modal, ModalProps } from '@mantine/core';

interface IProps {
  title?: string | React.ReactNode;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  centered?: boolean;
  size?: string;
  closeOnClickOutside?: boolean;
  padding?: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  radius?: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  transition?: MantineTransition;
  zIndex?: number;
  // overflow?: ModalProps['overflow']
  onClose?: () => void;
}

export function EModal({
  title,
  isOpen,
  setIsOpen,
  children,
  centered = true,
  size,
  closeOnClickOutside,
  padding,
  radius,
  transition,
  footer,
  zIndex,
  // overflow,
  onClose
}: IProps) {
  return (
    <Modal
      title={title || ""}
      opened={isOpen}
      onClose={function (): void {
        setIsOpen(false);
        onClose && onClose();
      }}
      centered={centered}
      size={size}
      closeOnClickOutside={closeOnClickOutside}
      padding={padding || 'md'}
      radius={radius || 'lg'}
      zIndex={zIndex}
      styles={{
        overlay: {
          // backgroundColor: 'rgba(0, 0, 0, 0.45)',
          backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.0) 0%, rgba(0, 0, 0, 0.5) 100%)',
          // backdropFilter: 'blur(8px)',
        },
        // body: {
        //   backgroundColor: 'rgba(255, 255, 255, 0.8)',
        //   border: '8px solid red',
        // },
        content: {
          border: '6px solid white',
          backgroundColor: '#F5F5F5',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
          overflow: 'hidden',
        },
        header: {
          marginBottom: '12px',
          padding: '12px',
          backgroundColor: '#F5F5F5',
          borderBottom: '1px solid #E5E7EB',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      {children}
    </Modal>
  );
}
